import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";
import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { IFillDataWizardBuy } from "../../..";
import Button from "../../../../../../../ui/button";
import AuthModal from "../../../../../../auth/components/modals/authModal";
import { useNavigate } from "react-router-dom";
import { getAccessToken } from "../../../../../../../../lib/services/localStorage.service";
import useDealRequestExchange, {
  EDealRequestLinkType,
} from "../../../../../../../../api/hooks/use-deal-request-exchange";
import { toast } from "react-toastify";
import { PATHS } from "../../../../../../../shared/constants";
import useOpenModal from "../../../../../../../ui/modal/hooks/useOpenModal";

interface ISelectionByOwnSwapStep_16 {
  data: IFillDataWizardBuy;
}

const SelectionByOwnSwapStep_16 = ({ data }: ISelectionByOwnSwapStep_16) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_15);
  };

  const navigate = useNavigate();

  const { error, isMutating, trigger } = useDealRequestExchange();

  const {
    offsetY: offsetYAuth,
    open: openAuth,
    handleChangeModal: handleChangeModalAuth,
  } = useOpenModal();

  const handleSendData = async () => {
    if (getAccessToken()) {
      try {
        await trigger({ type: EDealRequestLinkType.Swap, data });
        toast.success("Заявка на обмен создана");
        navigate(`/${PATHS.myDeal}`);
      } catch (error: any) {
        if (error?.message === "Unauthorized") {
          handleChangeModalAuth(true);
        }
        toast.error("Ошибка не удалось отправить заявку");
      }
    } else {
      handleChangeModalAuth(true);
    }
  };

  return (
    <div>
      <BaseStep prevStep={handlePrevStep} text="Отправка заявки:">
        <div>
          <Button
            label="Отправить заявку на покупку"
            onClick={handleSendData}
          />
          <AuthModal
            opened={openAuth}
            onClose={() => handleChangeModalAuth(false)}
            offsetY={offsetYAuth}
          />
        </div>
      </BaseStep>
    </div>
  );
};

export default SelectionByOwnSwapStep_16;
